import { Grid, Stack, Typography } from '@mui/material';
import { Hymn } from 'models/Hymn';
import React from 'react';

function Row({ title, detail }: { title: string; detail: string }) {
  return (
    <Grid container>
      <Grid item xs={2}>
        <Typography variant="caption">{title}:</Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography variant="caption">{detail}</Typography>
      </Grid>
    </Grid>
  );
}

interface HymnDetailsProps {
  hymn: Hymn;
}

function HymnDetails({ hymn }: HymnDetailsProps) {
  return (
    <tr>
      <td colSpan={4}>
        <Stack style={{ margin: '20px' }}>
          <Row title="Title" detail={hymn.title} />
          <Row title="Number" detail={`${hymn.number}`} />
        </Stack>
      </td>
    </tr>
  );
}

export default HymnDetails;
